/* eslint-disable guard-for-in */
import chttp from '@/libs/base/coupon_http';
import http from '@/libs/base/http';
import apis from '@/libs/base/apis';
import cookie from '@/libs/utils/cookie';
import Vue from 'vue';
import get from 'lodash/get';

let customerCountdownTimer = null
// eslint-disable-next-line no-unused-vars
const leike_black_arr = ['THUNDER_A40_ARMY']

export default {
  getAppletData({
    commit,
    dispatch,
  }) {
    dispatch('getData', {
      keyName: 'applet_pic_config',
      callback: (res) => {
        commit('SAVE_APPLET_CONFIG', get(res, 'data.srcList', []));
      },
    });
  },
  getUserRole({
    commit,
    state,
  }) {
    const params = {
      unionid: state.unionid,
    };
    // 从 localStorage 读取 role，如果有就添加到请求参数中
    const savedRole = localStorage.getItem('userRole');
    if (savedRole) {
      params.role = savedRole;
    }
    return chttp.get(apis.configGetrole, { params }).then((res) => {
      const newRole = res.data.role;
      commit('SAVE_USER_ROLE', newRole);
      // 如果返回的 role 有更新（或首次获取），就更新 localStorage
      if (newRole && newRole !== savedRole) {
        localStorage.setItem('userRole', newRole);
      }
    })
  },
  getHomeConfig({
    commit,
    state,
    dispatch,
  }, payload) {
    const params = {
      openid: state.openid || 'oBk-Cwb-8Hm1aVwN6cyG1mE_X61w',
      unionid: state.unionid || 'o6qE3t4jC2244YChVNoC8XJpFDwY',
    };
    // 从 localStorage 读取 role，如果有就添加到请求参数中
    const savedRole = localStorage.getItem('userRole');
    if (savedRole) {
      params.role = savedRole;
    }
    chttp.get(apis.configApi, { params }).then((res) => {
      const { data } = res;
      const themePages = ['/thunder/home', '/thunder/search', '/thunder/ordered', '/thunder/singer', '/thunder/tops', '/thunder/singerdetail', '/thunder/classified_songlist'];
      const isThemePages = themePages.find((themePage) => !!location.href.includes(themePage));

      // 只要是首页就使用蓝色主题，其他页面使用light主题
      // vip-toast-pay 背景层显示首页内容，需保持蓝色主题，不受此处覆盖
      const fromVipToastPay = sessionStorage.getItem('fromVipToastPay');
      const theme = (isThemePages || fromVipToastPay) ? 'blue' : 'light';
      commit('SET_THEME', theme);
      commit('SAVE_EXPERIMENT_CONFIG', get(data, 'experiment', {})); // 实验配置信息
      commit('SAVE_VIP_BALANCE', data.charge.balance); // 用户余额
      commit('SAVE_KTV_INFO', data.stb); // 房台信息
      commit('SAVE_PACKAGE_DISCOUNT_RIGHTS', data.charge.rights); // 礼物/祝福/冠名/照片免费次数
      commit('SAVE_ROOM_INTERACTION', data.stb.func); // 房台支持版本信息
      commit('BLESS_PATH', data.stb.func.ba); // 雷石功能版本控制文档：https://m2miovoqda.feishu.cn/wiki/wikcnaV2f5St2G9xiQYWJIHKVqc
      commit('PHOTO_PATH', data.stb.func.photo);
      commit('PHOTO_PATH_NEW', data.stb.func.photo);
      commit('PHOTO_INTERACT_PATH_NEW', data.stb.func.photo);
      // eslint-disable-next-line no-underscore-dangle
      commit('SAVE_DEVICE_INFO', data.stb.func._m); // 修改了这里，去掉了下划线
      commit('SAVE_HOME_USER_INFO', res.data); // 用户信息
      // 检查是否在退款黑名单中，如果是则跳转到拦截申诉页面
      // 允许访问拦截申诉页面和申诉页面
      const isRefundBlack = get(data, 'user.is_refund_black', 0);
      const currentPath = location.href;
      const isOnAllowedPage = currentPath.includes('/thunder/intercept_appeal')
        || currentPath.includes('/thunder/appeal');
      if (isRefundBlack === 1 && !isOnAllowedPage) {
        setTimeout(() => {
          if (process.env.NODE_ENV === 'development') {
            location.hash = '#/thunder/intercept_appeal';
          } else {
            location.href = '/thunder/intercept_appeal';
          }
        }, 100);
        return;
      }
      commit('SAVE_HOME_TOAST', !payload.isPop); // 遥控页弹窗不显示开屏弹窗
      commit('SET_SONG_ADDED_TOAST', res.data.is_song_added_toast);
      commit('SHOW_HOME_BOTTOM_AD', true);
      commit('SAVE_LITONG_INFO', res.data.litong); // 跳转利通小程序的信息
      // 活动信息
      commit('SET_ACTIVITY_OVER', !!data.ball.isfinish); // 砸金蛋活动是否结束
      commit('SET_RANK_INFO', data.lsk); // 雷石k歌信息
      commit('SET_VIP_LEVEL', data.user.pkg_id); // 购买的会员种类
      // 免费领取60s会员
      commit('SAVE_VIP_EXPERIENCE', { 'hasFreeVipM': data.hasFreeVipM, 'isFreeVipM': data.isFreeVipM })

      if (get(data, 'issuedSong.songid')) { // 手机专享点歌
        dispatch('orderPhoneSong', res.data.issuedSong);
      }
      if (payload.callback) {
        payload.callback();
      }
      cookie.setCookie(data.stb.no_any_recreation, 1, 'isSupportInteract');
      cookie.setCookie(data.stb.ktvid, 1, 'ktvid');
      localStorage.setItem('statInfo', JSON.stringify(data.stb));
      localStorage.setItem('userInfo', JSON.stringify(data.user));
      // 如果返回的 role 有更新（或首次获取），就更新 localStorage
      const newRole = res.data.role;
      if (newRole && newRole !== savedRole) {
        localStorage.setItem('userRole', newRole);
      }
      // 雷客安卓
      // eslint-disable-next-line no-underscore-dangle
      if (data.stb.stat.includes('os=android') && state.is_leike_device && !leike_black_arr.includes(data.stb.func._m)) {
        dispatch('getLeikeInfoTime')
      }
      if (!state.init_enter) return;
      const notStatisticsPages = ['/thunder/code', '/thunder/nobind'];
      // 不需要统计pv和uv的页面路由
      const isNotStatisticsPages = notStatisticsPages.find((notStatisticsPage) => !!location.href.includes(notStatisticsPage));
      // disableSTAT：如果页面有请求需要设置disableSTAT:true,否则会出现访问一次上报两条路由信息
      // eg: src/views/vip/openvip.vue
      if (!isNotStatisticsPages && !payload.disableSTAT) {
        commit('PAGE_STATISTICS', {
          url: location.pathname || location.hash || location.href,
        });
        if (!state.have_gift) return;
        let isShowSpecialEffict = cookie.getCookie('isShowSpecialEffict');
        const ktvid = cookie.getCookie('ktvid');
        if (ktvid !== data.stb.ktvid) {
          isShowSpecialEffict = '';
          cookie.setCookie('', 1, 'isShowSpecialEffict');
        }
        if (state.bind_status && !isShowSpecialEffict && state.is_vip) {
          dispatch('sendSpecialEffict');
          cookie.setCookie(1, 1, 'isShowSpecialEffict');
        }
      }
    }).catch(() => {
    });
  },
  getUserInfo({ // 用户信息/是否是vip
    commit,
    state,
  }) {
    const openid = state.openid || 'oBk-Cwb-8Hm1aVwN6cyG1mE_X61w';
    const unionid = state.unionid || 'o6qE3t4jC2244YChVNoC8XJpFDwY';
    chttp.get(`${apis.userInfo}?openid=${openid}&unionid=${unionid}`).then((res) => {
      commit('SAVE_USER_INFO', res || {});
      commit('SAVE_VIP_BALANCE', res.balance);
      commit('SAVE_CHARGE_RIGHTS', res.rights);
    }).catch(() => {
    });
  },
  rankSongData({
    commit,
    state,
  }, callback) {
    const params = {
      openid: state.openid,
      unionid: state.unionid,
    };
    chttp.get(apis.rankHome, { params }).then((res) => {
      commit('SET_RANK_INFO', res.data || {});
      if (callback) {
        callback(status, res);
      }
    });
  },
  // 发送 PAG 进场特效
  sendPAGEffict({ state }) {
    const index = parseInt(localStorage.getItem('special-effict-index-pag'), 10) || 0;
    const effectArr = [
      'https://qncweb-back1.ktvsky.com/20220809/other/257bfbc988ca0d85e0c2d03de43e2c38.png',
      'https://qncweb-back1.ktvsky.com/20220809/other/b055d47d5b5e3e3aa059cac0ac88a4c2.png',
    ];
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      img_url: effectArr[index],
      gb_count_switch: 0,
      is_pag: 1,
      pag_tp: index + 1,
    };
    chttp.get('https://m.ktvsky.com/c1/gift/send', { params })
      .then((res) => {
        if (res.errcode === 200) {
          // Vue.$toast('请看大屏幕')
        } else {
          Vue.$toast('发送失败');
        }
      });
  },
  sendSpecialEffict({ state, dispatch }) {
    if (state.supportPAG) {
      dispatch('sendPAGEffict')
      return
    }
    const index = parseInt(localStorage.getItem('special-effict-index'), 10) || 0;
    const imgArr = ['https://qncweb-back1.ktvsky.com/20200211/vadd/02d9917c7959453167c9d9781b2fadb6.png',
      'https://qncweb-back1.ktvsky.com/20200211/vadd/3ae26045b348e39abbcd70c866f4d8a7.png'];
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      img_url: imgArr[index],
      gb_count_switch: 0,
    };
    chttp.get(apis.giftSend, { params })
      .then((res) => {
        if (res.errcode === 200) {
          // Vue.$toast('请看大屏幕')
        } else {
          Vue.$toast('发送失败');
        }
      });
  },
  getADInfo({ state }) {
    state.ad_src = 'https://qncweb-back1.ktvsky.com/20200310/vadd/ac47429280f0eea80498b380f36c9d1e.jpg';
  },
  // eslint-disable-next-line
  getData({ state }, payload) {
    chttp.get(`${apis.getDataCommonApi}?key=vadd_cms_${payload.keyName}`).then((res) => {
      payload.callback(res);
    });
  },
  orderPhoneSong({ state }, payload) {
    if (!state.bind_status) {
      return Vue.$store.commit('SAVE_SHOW_SCODE_BOX', true);
    }
    state.payload = payload;
    Vue.$messageBox.confirm(`现在点播“${payload.music_name}”歌曲`)
      .then(() => {
        const params = {
          musicname: payload.music_name,
          openid: state.openid,
          unionid: state.unionid,
          songid: payload.songid,
          origin: state.type,
          singer: payload.singer,
          ktvid: state.ktv_id,
          parm: JSON.stringify({
            vip: state.is_vip ? 1 : 0,
            isRecord: 0,
            isScore: 0,
            isForceJinhai: 0,
            label_type: payload.type,
          }),
          fr: 'issuedSong',
        };
        chttp.post(apis.orderSong, params)
          .then((res) => {
            if (res.errcode === 21001 || res.errcode === 200) {
              Vue.$toast('点歌成功');
            }
          });
      });
      Vue.$sendLog({
        event_type: 'show',
        event_name: '进入点歌台带toast界面',
        event_data: {
          action: `现在点播“${payload.music_name}”歌曲`,
        },
      });
  },
  async getLikeSong({ state, commit }) {
    if (state.likeSongs.length) return;
    const params = {
      unionid: state.unionid,
      openid: state.openid,
      sex: state.sex,
      type: '我的常唱',
    };
    const res = await chttp.get(apis.topList, { params });
    let songs = res.data || [];
    if (!songs.length) {
      songs = Vue.$store2('mySongs') || [];
    }
    commit('SET_CCTOTAL', res.ccTotal);
    commit('SET_LIKE_SONG_NEW', !!res.is_empty);
    commit('SET_LIKE_SONG', songs);
  },
  async getAutoOrderSong({ state, dispatch }, payload) {
    let songs = [];
    const params = {
      unionid: state.unionid,
      openid: state.openid,
    };
    const res = await http.get(`${process.env.VUE_APP_COUPON_URL}${apis.autoOrderSong}?BaseUrlType=other`, { params });
    songs = get(res, 'result', []);
    if (cookie.getCookie('likeSongOrder') !== '1' && state.bind_status && songs.length) {
      cookie.setCookie('1', 1, 'likeSongOrder');
      const AutoOrderToastcallBack = () => {
        Vue.$toast({
          message: '陛下~已为您自动点歌<br/><span style="text-decoration:underline;">去「已点」查看</span>',
          duration: 5000,
          callback: () => {
            payload.router.push('/thunder/ordered');
          },
        });
      };
      songs.forEach((item, index) => {
        setTimeout(() => {
          dispatch('orderSongs', {
            item,
            callback: index === (songs.length - 1) && AutoOrderToastcallBack,
          });
        }, index * 2000);
      });
    }
  },
  orderSongs({ state }, payload) {
    const { item } = payload;
    const parm = {
      vip: state.is_vip ? 1 : 0,
      isRecord: 0,
      isScore: 0,
      isForceJinhai: 0,
      label_type: item.type,
    };
    const params = {
      musicname: item.music_name,
      openid: state.openid,
      unionid: state.unionid,
      songid: item.songid,
      origin: 'like',
      singer: item.singer,
      ktvid: state.ktv_id,
      parm: JSON.stringify(parm),
    };
    chttp.post(apis.orderSong, params)
      .then((res) => {
        this.orderloading = false;
        if (res.errcode === 21001 || res.errcode === 200) {
          if (payload.callback) {
            payload.callback();
          }
        }
      }).catch(() => {
        this.orderloading = false;
      });
  },
  getGoldBaochang({ // 金主信息
    commit,
    state,
  }, callback) {
    const params = {
      openid: state.openid || 'oBk-Cwb-8Hm1aVwN6cyG1mE_X61w',
      unionid: state.unionid || 'o6qE3t4jC2244YChVNoC8XJpFDwY',
    };
    chttp.get(apis.goldBaochang, { params }).then((res) => {
      if (res.errcode === 200) {
        commit('SET_IS_GOLD', true);
        const data = res.data.user;
        const stateData = {
          nickname: data.nickname,
          headimgurl: data.headimgurl,
          end_time: res.data.end_time,
          appid: data.appid,
          userid: data.unionid,
        };
        commit('SET_GOLD_MESSAGE', stateData);
        commit('SET_GOLD_MASTER', !!res.data.is_jz);
        commit('SET_IS_VIP', {
          vip: res.vip,
          end_time: res.vip_endtime,
        });
      }
      if (typeof callback === 'function') {
        callback();
      }
    });
  },
  getSingleRights({ // 用户信息/是否是单人包场
    commit,
    state,
  }, callback) {
    const params = {
      // openid: state.openid || 'oBk-Cwb-8Hm1aVwN6cyG1mE_X61w',
      unionid: state.unionid || 'o6qE3t4jC2244YChVNoC8XJpFDwY',
    };
    chttp.get(apis.singleRightsInfo, { params }).then((res) => {
      if (res.errcode === 200) {
        commit('SET_IS_SINGLE_RIGHTS', {
          isSolobc: res.data.isSolobc,
          endTime: res.data.endTime,
        });
      }
      if (typeof callback === 'function') {
        callback();
      }
    });
  },
  getIsVip({
    commit,
    state,
  }, callback) {
    const params = {
      openid: state.openid,
      unionid: state.unionid,
    };
    chttp.get(apis.getIsVip, { params }).then((res) => {
      if (res.errcode === 200) {
        commit('SET_IS_VIP', res);
        commit('SAVE_IS_RAISE', res)
      }
      if (callback && typeof callback === 'function') {
        callback();
      }
    });
  },
  // 9.9金主
  buyGoldBaochang({ state, dispatch }, data) {
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      entrance: data.entrance,
      pay_fee: data.pay_fee,
    };
    dispatch('wxpay', {
      params,
      wxUrl: apis.goldBaochangWxpay,
      elseData: {
        callback: () => {
          if (data.callback) {
            data.callback();
          }
        },
      },
    });
  },
  // 0元金主
  buyFreeGold({ state }) {
    const params = {
        roomid: state.roomid,
        unionid: state.unionid,
      };
    return new Promise((resolve, reject) => {
      chttp.post(apis.freeOpenGold, params).then(() => {
        resolve()
      }).catch(() => { reject() })
    })
  },
  buySinglePoint({ state, dispatch }, data) {
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      entrance: data.entrance,
      pay_fee: data.pay_fee,
      song_id: data.song_id,
      song_name: data.song_name,
      appid: state.appId,
    };
    dispatch('wxpay', {
      params,
      wxUrl: apis.singlePoint,
      elseData: {
        callback: () => {
          if (data.callback) {
            data.callback();
          }
        },
      },
    });
  },
  buySingleRights({ state, dispatch }, data) {
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      entrance: data.entrance,
      pay_fee: data.pay_fee,
      is_miniapp: data.is_miniapp,
      // appid: state.appId,
    };
    dispatch('wxpay', {
      params,
      wxUrl: apis.singleRightsPay,
      elseData: {
        callback: () => {
          if (data.callback) {
            data.callback();
          }
        },
      },
    });
  },
  buyBargainVIP({ state, dispatch }, data) {
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      pay_enter: data.pay_enter,
      pay_fee: data.pay_fee,
      pkg_id: data.pkg_id,
      // is_miniapp: data.is_miniapp,
      // appid: state.appId,
    };
    dispatch('wxpay', {
      params,
      wxUrl: apis.bargainVIP,
      elseData: {
        callback: () => {
          if (data.callback) {
            data.callback();
          }
        },
      },
    });
  },
  // 获取用户已点歌曲数量
  getOrderedSongNum({ commit, state }, type) {
    // type: -1-减少数量, 0-获取实际数量, 1-增加数量
    if (type == 1) {
      // 增加数量
      let { orderedSongNum } = state;
      // 将 orderedSongNum 转换为数字并增加 1
      commit('CHANGE_ORDEREDSONG_NUM', Number(orderedSongNum) + 1);
      return;
    }

    if (type == -1) {
      // 减少数量
      let { orderedSongNum } = state;
      // 将 orderedSongNum 转换为数字并减少 1，确保不小于 0
      commit('CHANGE_ORDEREDSONG_NUM', Math.max(0, Number(orderedSongNum) - 1));
      return;
    }

    // 通过接口获取实际数量
    const params = {
      openid: state.openid,
      unionid: state.unionid,
    };
    chttp.get(apis.song_list, { params })
      .then((res) => {
        if (res.errcode === 200) {
          // 将返回的数据长度作为数字
          commit('CHANGE_ORDEREDSONG_NUM', res.data.length);
        }
      })
      .catch((err) => {
        console.error('获取已点歌曲数量失败:', err);
      });
  },

  // 获取用户自己点的歌曲数量
  getMyOrderedSongNum({ commit, state }, increment = false) {
    if (increment) {
      // 增加计数
      let { myOrderedSongNum } = state;
      commit('CHANGE_MYORDEREDSONG_NUM', Number(myOrderedSongNum) + 1);
      return;
    }

    // 获取实际数量
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      own: 1,
    };
    chttp.get(apis.song_list, { params })
      .then((res) => {
        if (res.errcode === 200) {
          // 过滤掉已经播放完的歌曲(played=2)
          const activeSongs = res.data.filter((item) => item.played !== 2);
          commit('CHANGE_MYORDEREDSONG_NUM', activeSongs.length);
        }
      })
      .catch((err) => {
        console.error('获取我的已点歌曲数量失败:', err);
      });
  },
  handleShow({ state }, data) {
    const action = data.key === 'xiu' ? '【秀一下】' : '【赞ta】';
    Vue.$sendLog({
      event_type: 'click',
      event_name: data.pagename,
      event_data: {
        action,
      },
    });
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      img_url: data.imgurl,
      gb_count_switch: 0,
      count: data.num,
    };
    chttp.get(apis.giftSend, { params })
      .then((res) => {
        if (res.errcode === 200) {
          Vue.$toast(data.txt);
        }
      });
  },
  getGmSwitch({
    commit,
    state,
  }) {
    const params = {
      openid: state.openid,
      unionid: state.unionid,
    };
    chttp.get(apis.gmSwitch, { params }).then((res) => {
      if (res.errcode === 200) {
        commit('SET_GM_SWITCH', res.status);
      }
    });
  },
  // 获取雷客盒子是否过期
  getLeikeInfo({
    commit,
    state,
  }) {
    const ONEDAY_TIMESTAMP = 24 * 60 * 60 * 1000;
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      room_id: state.roomid,
      ktvid: state.ktvid
    };
    chttp.get(apis.leikeInfo, { params }).then((res) => {
      this.vip_endtime = res.data.vip_time
      const days = Math.ceil((new Date().getTime() - new Date(this.vip_endtime).getTime()) / ONEDAY_TIMESTAMP);
      this.url = res.data.open1
      if (res.errcode === 200) {
        if (days > 0) {
          commit('SAVE_LEIKE_LINUX_IFNO', {
            isLeikeExpire: true,
            leikeJumpUrl: res.data.open1
          });
        }
      }
    });
  },
  // 获取机顶盒会员还有多少天
  getLeikeInfoTime({
    commit,
    state,
  }) {
    const params = {
        openid: state.openid,
        unionid: state.unionid,
        room_id: state.roomid,
        ktvid: state.ktvid
    };
    chttp.get(apis.leikeInfo2, { params }).then((res) => {
        const { data } = res
        const url = data.open1;
        if (data.remain_days > 0 || data.buy_dev_packet_remain_days > 0) {
            commit('SAVE_SETTOP_DATE', true);
            if (url.includes('os=linux')) {
                commit('SAVE_SETTOP_DATE', false);
            }
        }
    });
  },
  setCustomerCountdown({ commit, state }, process) {
    // 如果有定时器需要先清掉旧的再开启新的定时器
    if (customerCountdownTimer || !process) {
      clearInterval(customerCountdownTimer)
      customerCountdownTimer = null
    }
    if (process) {
      let start = process
      commit('SET_CUSTOMER_COUNTDOWN', Math.ceil(start))
      customerCountdownTimer = setInterval(() => {
        commit('SET_CUSTOMER_COUNTDOWN', Math.ceil(start - 1))
        start = state.customerCountProcess
        if (state.customerCountProcess <= 0) {
          clearInterval(customerCountdownTimer)
          customerCountdownTimer = null
        }
      }, 1000)
    } else if (process === 0) {
      commit('SET_CUSTOMER_COUNTDOWN', 0)
    }
  },
  toAIMV({ state }, data) {
    Vue.$sendLog({
      event_type: 'click',
      event_name: 'AI换脸-点击',
      event_data: {
        desc: data.name,
      },
    });
    window.location.href = `${window.location.origin}/smartplant/#/?openid=${state.openid}&unionid=${state.unionid}&fromType=${data.from}&fr=vadd`;
  },
};
